import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const Container = styled.div`
  max-width: 600px;
  margin: 40px auto;
  padding: 30px;
  background-color: ${props => props.theme.card};
  border-radius: 8px;
  box-shadow: ${props => props.theme.shadow};
  text-align: center;
`;

const Title = styled.h1`
  color: ${props => props.theme.primary};
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  
  span {
    font-size: 32px;
  }
`;

const Message = styled.p`
  margin-bottom: 20px;
  color: ${props => props.theme.text};
`;

const Button = styled.button`
  padding: 12px 24px;
  background-color: ${props => props.theme.primary};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 20px;
  
  &:hover {
    background-color: ${props => props.theme.primaryHover};
  }
`;

const Error = styled.div`
  color: ${props => props.theme.error};
  margin-bottom: 15px;
  padding: 10px;
  background-color: ${props => props.theme.errorBg};
  border-radius: 4px;
`;

const VerifySuccess = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { verifyEmail, isAuthenticated } = useAuth();
  
  useEffect(() => {
    const processVerification = async () => {
      try {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');
        
        if (!token) {
          setError('Token de verificación no encontrado');
          setLoading(false);
          return;
        }
        
        // Solo iniciar sesión con el token si no estamos ya autenticados
        if (!isAuthenticated) {
          // Intentar verificar e iniciar sesión con el token
          const result = await verifyEmail(token);
          
          if (result.success) {
            setLoading(false);
          } else {
            setError(result.message || 'Error al procesar la verificación');
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      } catch (err) {
        setError(err.message || 'Error al procesar la verificación');
        setLoading(false);
      }
    };
    
    processVerification();
  }, [location, verifyEmail, isAuthenticated]);
  
  const handleContinue = () => {
    navigate('/');
  };
  
  return (
    <Container>
      {loading ? (
        <Message>Procesando verificación...</Message>
      ) : error ? (
        <>
          <Title><span>⚠️</span> Error de verificación</Title>
          <Error>{error}</Error>
          <Button onClick={() => navigate('/')}>Volver al inicio</Button>
        </>
      ) : (
        <>
          <Title><span>✅</span> ¡Verificación exitosa!</Title>
          <Message>Tu cuenta ha sido verificada correctamente. Ya puedes acceder a todas las funcionalidades de Sapotix.</Message>
          <Button onClick={handleContinue}>Continuar a Sapotix</Button>
        </>
      )}
    </Container>
  );
};

export default VerifySuccess; 